import { mergeAttributes, Node } from '@tiptap/core';

export type Size = number;
export type Unit = 'px' | 'em' | 'rem' | 'mm' | 'cm' | 'pt' | 'pc' | 'ex' | 'ch' | '%';

export interface FontOptions {
	sizes: Array<Size>;
	HTMLAttributes: Record<string, unknown>;
	types: Array<string>;
	unit: Unit;
}

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		font: {
			setFontSize: (size: Size) => ReturnType;
			unsetFontSize: () => ReturnType;
		};
	}
}

const FontSize = Node.create<FontOptions>({
	name: 'font',

	addOptions() {
		return {
			sizes: [10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42, 48, 54, 60, 66, 72, 78],
			HTMLAttributes: {},
			types: ['textStyle'],
			unit: 'px',
		};
	},
	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					fontSize: {
						default: null,
						parseHTML: (element) => element.style.fontSize?.replace(/['"]+/g, ''),
						renderHTML: (attributes: { fontSize: Size }) => {
							if (!attributes.fontSize) {
								return {};
							}
					
							return {
								style: `font-size: ${attributes.fontSize}${typeof attributes.fontSize === 'number' ? this.options.unit : ''}`,
							};							
						},
					},
				},
			},
		];
	},

	renderHTML({ HTMLAttributes }) {
		return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
	},

	addCommands() {
		return {
			setFontSize:
				(size) =>
				({ chain }) =>
					chain().setMark('textStyle', { fontSize: size }).run(),
			unsetFontSize:
				() =>
				({ chain }) =>
					chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run(),
		};
	},
});

export { FontSize };
